import { Rocket } from "lucide-react";

const STEPS = ["queued", "in_progress", "live"];
const LABEL = { awaiting_details: "Waiting for your domain", queued: "Queued", in_progress: "In progress", live: "Live" };

export const DfyStatus = ({ deployment }) => {
  if (!deployment) return null;
  const idx = STEPS.indexOf(deployment.status);
  return (
    <section className="iv-glass space-y-3 rounded-2xl p-5" data-testid="dfy-status-card">
      <p className="flex flex-wrap items-center gap-2 font-bold text-white">
        <Rocket className="h-4 w-4 text-emerald-300" aria-hidden="true" /> Production Website Launch
        <span className="rounded-full bg-emerald-400/15 px-2 py-0.5 text-[11px] text-emerald-200" data-testid="dfy-status-label">{LABEL[deployment.status]}</span>
      </p>
      <ol className="flex flex-wrap gap-2 text-xs" aria-label="Launch progress">
        {STEPS.map((s, i) => (
          <li key={s} className={`rounded-full px-3 py-1 ${i <= idx ? "bg-emerald-500/20 text-emerald-100" : "bg-white/5 text-slate-500"}`} data-testid={`dfy-step-${s}`}>{LABEL[s]}</li>
        ))}
      </ol>
      <p className="text-sm text-slate-300" data-testid="dfy-domain">
        {deployment.desired_domain ? `Domain: ${deployment.desired_domain} · Brand: ${deployment.brand_name}` : (
          <a href={`/payment/success?order_id=${deployment.order_id}`} className="font-semibold text-cyan-300" data-testid="dfy-finish-details">Add your domain to start the launch</a>
        )}
      </p>
      <p className="text-xs text-slate-500">Fulfilled by the IdeaValidator360 team within 48 hours. Your test preview never expires.</p>
    </section>
  );
};
